import { render } from "./App.vue?vue&type=template&id=0ffac212&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=0ffac212&lang=scss"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"
import "./App.vue?vue&type=style&index=2&id=0ffac212&lang=css"

import exportComponent from "D:\\project\\unnati\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__